const articleHtml = document.querySelector(".article-template__content");
const titles = [...articleHtml.children].filter((item) =>
  item.tagName.startsWith("H")
);

const hierarchy = buildHierarchy(titles);
const tocList = document.querySelector("#table-of-content ul");

const tocHandle = document.querySelector(".toc-handle");
tocHandle.addEventListener("click", (e) => {
  const isOpened = tocHandle.classList.contains("opened");
  console.log(isOpened);
  const targetHeight = tocList.parentElement.scrollHeight;
  if (isOpened) {
    tocList.parentElement.style.height = "0px";
    tocHandle.classList.remove("opened");
  } else {
    tocList.parentElement.style.height = targetHeight + "px";
    tocHandle.classList.add("opened");
  }
});

hierarchy.forEach((hierarchyItem) => {
  const tocListItem = createTOCListItem({ hierarchyItem });
  if (tocListItem) tocList.append(tocListItem);
});

function buildHTMLElementNode(element) {
  return {
    element: element,
    children: [],
    addChild: function (child) {
      this.children.push(child);
    },
  };
}

function buildHierarchy(titles) {
  const root = buildHTMLElementNode(null);
  let hierarchyStack = [{ node: root, level: 0 }];

  for (const title of titles) {
    const level = parseInt(title.tagName.slice(1));
    const node = buildHTMLElementNode(title);

    while (
      hierarchyStack.length > 0 &&
      hierarchyStack[hierarchyStack.length - 1].level >= level
    ) {
      hierarchyStack.pop();
    }

    if (hierarchyStack.length > 0) {
      hierarchyStack[hierarchyStack.length - 1].node.addChild(node);
    }

    hierarchyStack.push({ node: node, level: level });
  }

  return root.children;
}

function createTOCListItem({ hierarchyItem }) {
  const heading = hierarchyItem.element;
  if (!heading.innerText) return;
  heading.id = encodeURIComponent(heading.innerText);
  const li = document.createElement("li");

  const a = document.createElement("a");
  a.href = "javascript:void(0);";
  a.innerText = heading.innerText.replace(/(\r\n|\n|\r)/g, "");
  li.appendChild(a);

  if (hierarchyItem.children.length > 0) {
    li.classList.add("toc--list-item__with-children");
    const childUl = document.createElement("ul");
    childUl.classList.add("toc--list-item__children");
    hierarchyItem.children.forEach((child) => {
      const childLi = createTOCListItem({ hierarchyItem: child });
      childUl.appendChild(childLi);
    });

    li.appendChild(childUl);

    li.addEventListener("click", (e) => {
      const isOpened = childUl.classList.contains("open");
      childUl.classList.toggle("open");
      childUl.style.maxHeight = isOpened
        ? 0
        : childUl.children.length * 96 + "px";
      li.classList.toggle("toc--list-item__with-children__opened");
    });
  }

  a.addEventListener("click", (e) => {
    e.stopPropagation();
    const headerOffset = 124;
    const elementPosition = heading.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - headerOffset;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  });

  return li;
}
